import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import App from "./App.tsx";
import "./index.css";
import WindowHeightChecker from "./provider/WindowHeightChecker.tsx";
import ToasterProvider from "./provider/ToasterProvider.tsx";

import { store } from "./store/store.ts";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { GOOGLE_RECAPTCHA_KEY } from "./utils/constant/globalEnv.constant.ts";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PWAUpdatePopUp } from "./components/popup/PWAUpdatePopUp.tsx";
import { GlobalModalProvider } from "./provider/GlobalModalProvider.tsx";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 0,
      staleTime: 0,
      refetchOnMount: "always",
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: false,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <GoogleReCaptchaProvider reCaptchaKey={GOOGLE_RECAPTCHA_KEY}>
        <Provider store={store}>
          <BrowserRouter basename="/">
            <GlobalModalProvider />
            <App />
          </BrowserRouter>
        </Provider>
      </GoogleReCaptchaProvider>
      <WindowHeightChecker />
      <ToasterProvider />
      <PWAUpdatePopUp />
    </QueryClientProvider>
  </StrictMode>
);
